export default () => {
  document.body.addEventListener('click', function (e) {
    const target = e.target;
    if (target.matches('[data-ge]') && typeof window.gtag != 'undefined') {
      const params = {};
      if (target.getAttribute('data-name')) {
        params.name = target.getAttribute('data-name');
      }
      gtag('event', target.getAttribute('data-ge'), params);
    }
  });
}
